module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-Regular.be82e38.ttf";